import React, { useState } from 'react';
import clsx from 'clsx';
import { Eye, EyeOff } from 'lucide-react';

export default function Input({
  label,
  error,
  helperText,
  className,
  leftIcon,
  rightIcon,
  type,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordType = type === 'password';
  const inputType = isPasswordType ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className={clsx('space-y-2', className)}>
      {label && (
        <label className="block text-sm font-medium text-text-secondary">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted">
            {leftIcon}
          </div>
        )}
        <input
          type={inputType}
          className={clsx(
            'w-full bg-bg-input border border-border-input rounded-lg px-4 py-2.5 text-text-primary placeholder-text-muted',
            'outline-none transition-all duration-200',
            'hover:border-border-light',
            'focus:border-accent-primary focus:ring-2 focus:ring-accent-primary/25 focus:bg-bg-input',
            error && 'border-loss focus:border-loss focus:ring-loss/25',
            props.disabled && 'opacity-60 cursor-not-allowed bg-bg-tertiary border-border',
            leftIcon && 'pl-10',
            (rightIcon || isPasswordType) && 'pr-10'
          )}
          {...props}
        />
        {isPasswordType && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted hover:text-text-secondary transition-colors"
          >
            {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        )}
        {rightIcon && !isPasswordType && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted">
            {rightIcon}
          </div>
        )}
      </div>
      {helperText && !error && (
        <p className="text-xs text-text-muted">{helperText}</p>
      )}
      {error && <p className="text-sm text-loss">{error}</p>}
    </div>
  );
}

export function Select({ label, error, helperText, className, children, ...props }) {
  return (
    <div className={clsx('space-y-2', className)}>
      {label && (
        <label className="block text-sm font-medium text-text-secondary">
          {label}
        </label>
      )}
      <select
        className={clsx(
          'w-full bg-bg-input border border-border-input rounded-lg px-4 py-2.5 text-text-primary',
          'outline-none transition-all duration-200 cursor-pointer',
          'hover:border-border-light',
          'focus:border-accent-primary focus:ring-2 focus:ring-accent-primary/25',
          error && 'border-loss focus:border-loss focus:ring-loss/25',
          props.disabled && 'opacity-60 cursor-not-allowed bg-bg-tertiary border-border'
        )}
        {...props}
      >
        {children}
      </select>
      {helperText && !error && (
        <p className="text-xs text-text-muted">{helperText}</p>
      )}
      {error && <p className="text-sm text-loss">{error}</p>}
    </div>
  );
}
